import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { TAdjustmentId } from '/src/lib/models';
import {
  TCreateAdjustmentRequest,
  TCreateAdjustmentResponse,
  TDeleteAdjustmentResponse,
  TGetAdjustmentResponse,
  TListAdjustmentsRequest,
  TListAdjustmentsResponse,
  TUpdateAdjustmentRequest,
  TUpdateAdjustmentResponse,
} from '/src/lib/types';

export class AdjustmentService {
  /**
   * List Adjustments
   * @returns Adjustment[]
   * @throws ApiError
   */
  public static async query(req?: TListAdjustmentsRequest): CancelablePromise<TListAdjustmentsResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/adjustments',
      query: req,
    })) as TListAdjustmentsResponse;

    return res;
  }

  /**
   * Get Adjustment
   * @param id TAdjustmentId
   * @returns Adjustment
   * @throws ApiError
   */
  public static async get(id: TAdjustmentId): CancelablePromise<TGetAdjustmentResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/adjustments/{id}',
      path: { id },
    })) as TGetAdjustmentResponse;

    return res;
  }

  /**
   * Create Adjustment
   * @param adjustment Adjustment
   * @returns Adjustment
   * @throws ApiError
   */
  public static async create(req: TCreateAdjustmentRequest): CancelablePromise<TCreateAdjustmentResponse> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/adjustments',
      body: req,
    })) as TCreateAdjustmentResponse;

    return res;
  }

  /**
   * Update Adjustment
   * @param adjustment Adjustment
   * @returns Adjustment
   * @throws ApiError
   */
  public static async update(
    id: TAdjustmentId,
    req: TUpdateAdjustmentRequest
  ): CancelablePromise<TUpdateAdjustmentResponse> {
    const res = (await __request(OpenAPI, {
      method: 'PUT',
      url: '/adjustments/{id}',
      path: { id },
      body: req,
    })) as TUpdateAdjustmentResponse;

    return res;
  }

  /**
   * Delete Adjustment
   * @param id TAdjustmentId
   * @returns Adjustment
   * @throws ApiError
   */
  public static async remove(id: TAdjustmentId): CancelablePromise<TDeleteAdjustmentResponse> {
    const res = (await __request(OpenAPI, {
      method: 'DELETE',
      url: '/adjustments/{id}',
      path: { id },
    })) as TDeleteAdjustmentResponse;

    return res;
  }
}
